import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import HttpService from '../https';
var classificationService = new HttpService({
  // disable custom headers to pass the CORS check
  withToken: false,
  withRequestId: false
});

/**
 * Get naming convention classification by classification id or name
 *
 * @param httpService - the HttpService.
 * @param versionId - Classification version uuid or the uniq name like uniclass-2015-2023-04
 * @param config - Configurable object to overwrite request parameters.
 * @returns a promise with classification data
 */
function fetchClassification(_x, _x2, _x3) {
  return _fetchClassification.apply(this, arguments);
}
/**
 * `Service` The Classification service, is used to fetch classification related data.
 */
function _fetchClassification() {
  _fetchClassification = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(httpService, versionId, config) {
    var _response$data;
    var url, response, _yield$classification, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          url = "/classification-versions/".concat(versionId);
          _context5.next = 3;
          return httpService.dmV3.get(url, config);
        case 3:
          response = _context5.sent;
          if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.storageUrl) {
            _context5.next = 6;
            break;
          }
          return _context5.abrupt("return", []);
        case 6:
          _context5.next = 8;
          return classificationService.get(response.data.storageUrl);
        case 8:
          _yield$classification = _context5.sent;
          data = _yield$classification.data;
          return _context5.abrupt("return", data);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fetchClassification.apply(this, arguments);
}
var ClassificationService = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function ClassificationService(sdk) {
    var _this;
    _classCallCheck(this, ClassificationService);
    _this = _callSuper(this, ClassificationService, [sdk]);
    _this.getClassificationFetchMap = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(ClassificationService, _Base);
  return _createClass(ClassificationService, [{
    key: "getVersions",
    value: (
    /**
     * Get system defined classification versions, order by release date DESC by default
     * https://platform.stoplight.autodesk.com/docs/docs-cp/665d280063529-get-system-defined-classification-versions
     *
     * @param params - The query parameters
     *   limit: the number of items to return, integer, range from 1 to 1000, default 200,
     *   offset: the number of items to skip before starting to collect the result set, 0 or positive integer, default 0,
     *   searchText: search classification version by name keywords
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{
     *   "results":[\{"id": string, "name": string, "displayName": string, "primary": boolean, "classificationSystem": string, "releaseDate": string\}],
     *   "pagination":\{"limit": integer, "offset": integer, totalResults: integer, nextUrl: string\}
     * \}
     */
    function () {
      var _getVersions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/classification-versions".concat(QS.stringify(params, {
                addQueryPrefix: true
              }));
              _context.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVersions(_x4, _x5) {
        return _getVersions.apply(this, arguments);
      }
      return getVersions;
    }()
    /**
     * Get detail classification version by id, the S3 storageUrl will returned in this API
     * https://platform.stoplight.autodesk.com/docs/docs-cp/bb734156b15c0-get-system-defined-classification-version-by-id
     *
     * @param versionId - Classification version uuid or the uniq name like uniclass-2015-2023-04
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{
     *   "id": string, "name": string, "displayName": string, "primary": boolean, "classificationSystem": string, "releaseDate": string
     * \}
     */
    )
  }, {
    key: "getVersion",
    value: (function () {
      var _getVersion = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(versionId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/classification-versions/".concat(versionId);
              _context2.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getVersion(_x6, _x7) {
        return _getVersion.apply(this, arguments);
      }
      return getVersion;
    }()
    /**
     * Get detail classification version by id, includes codes and descriptions
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Custom-Attribute.yaml/paths/~1classification-versions~1%7BclassificationVersionId%7D/get
     *
     * @param versionId - Classification version uuid or the uniq name like uniclass-2015-2023-04
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of [\{"code": string, "description": string\}]
     */
    )
  }, {
    key: "getAllVersionCodes",
    value: (function () {
      var _getAllVersionCodes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(versionId, config) {
        var fetchPromise, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              fetchPromise = this.getClassificationFetchMap.get(versionId); // make sure only 1 request for each classification id
              if (!fetchPromise) {
                fetchPromise = fetchClassification(this.HttpService, versionId, config);
                this.getClassificationFetchMap.set(versionId, fetchPromise);
              }
              _context3.prev = 2;
              _context3.next = 5;
              return fetchPromise;
            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", response);
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);
              this.getClassificationFetchMap["delete"](versionId);
              throw _context3.t0;
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 9]]);
      }));
      function getAllVersionCodes(_x8, _x9) {
        return _getAllVersionCodes.apply(this, arguments);
      }
      return getAllVersionCodes;
    }()
    /**
     * Get classification codes by classificationVersionId
     * https://platform.stoplight.autodesk.com/docs/docs-cp/55844f3292b23-get-classification-codes-by-keywords
     *
     * @param versionId - Classification version uuid or the uniq name like uniclass-2015-2023-04
     * @param params - The query parameters
     *   limit: the number of items to return, integer, range from 1 to 1000, default 200,
     *   offset: the number of items to skip before starting to collect the result set, 0 or positive integer, default 0,
     *   searchText: search classification version by name keywords
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise that shape of
     *   "results":[\{"code": string, "description": string\}],
     *   "pagination":\{"limit": integer, "offset": integer, totalResults: integer, nextUrl: string\}
     */
    )
  }, {
    key: "getVersionCodes",
    value: (function () {
      var _getVersionCodes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(versionId, params, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/classification-versions/".concat(versionId, "/classification-codes").concat(QS.stringify(params, {
                addQueryPrefix: true
              }));
              _context4.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getVersionCodes(_x10, _x11, _x12) {
        return _getVersionCodes.apply(this, arguments);
      }
      return getVersionCodes;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Classification';
    }
  }]);
}(Base);
export default ClassificationService;